/* assets/js/menu-slides.js
 *
 * Handles the slide navigation for the "menu‑slides" Liquid snippet.
 * ---------------------------------------------------------------
 *  • Clicking a menu item (".item") activates the slide whose
 *    ID matches the element’s `data-target` attribute.
 *  • The currently visible slide always has the class `active`.
 *  • Pressing the Escape key or clicking a element with
 *    `data-action="back"` returns to the main slide.
 */

document.addEventListener("DOMContentLoaded", () => {
  const slidesContainer = document.querySelector(".slides");
  if (!slidesContainer) return; // safety guard

  const globalBack = document.querySelector("#global-slide-back");
  const mainSlide = slidesContainer.querySelector(".slide.main-slide");
  const sublinks = slidesContainer.querySelectorAll(".slide .item.sublink");

  sublinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const item = e.currentTarget;
      const dropdownContent =
        item.parentElement.querySelector(".dropdown-content");

      item.classList.toggle("open");
      dropdownContent.classList.toggle("open");
    });
  });

  slidesContainer.querySelectorAll(".item[data-target]").forEach((item) => {
    item.addEventListener("click", () => {
      const targetSelector = item.dataset.target; // e.g. "#slide‑summer"
      const targetSlide = slidesContainer.querySelector(targetSelector);
      if (!targetSlide) return; // no slide with that ID → ignore

      // De‑activate the currently active slide
      const currentlyActive = slidesContainer.querySelector(".slide.active");
      if (currentlyActive) {
        // animate out the current slide
        currentlyActive.classList.add("slide-out");
        // wait for the out‑animation, then hide it
        setTimeout(() => {
          currentlyActive.classList.remove("active", "slide-out");

          globalBack.querySelector("span").innerHTML = item.dataset.title;
          globalBack.style.display = "flex";
        }, 100); // ← same duration as the CSS transition
      }

      // Activate the chosen slide with a slide‑in animation
      targetSlide.classList.add("active", "slide-in");
      // clean up the helper class after the animation finishes
      setTimeout(() => {
        targetSlide.classList.remove("slide-in");
      }, 250);
    });
  });

  slidesContainer.addEventListener("click", (e) => {
    const backTrigger = e.target.closest('[data-action="back"]');
    if (!backTrigger) return;

    const currentlyActive = slidesContainer.querySelector(".slide.active");
    if (currentlyActive) currentlyActive.classList.remove("active");

    if (mainSlide) mainSlide.classList.add("active");
  });

  globalBack.addEventListener("click", (e) => {
    const currentlyActive = slidesContainer.querySelector(".slide.active");
    if (currentlyActive) currentlyActive.classList.remove("active");

    if (mainSlide) mainSlide.classList.add("active");

    globalBack.style.display = "none";
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    const currentlyActive = slidesContainer.querySelector(".slide.active");
    if (!currentlyActive || currentlyActive === mainSlide) return;

    currentlyActive.classList.remove("active");
    if (mainSlide) mainSlide.classList.add("active");
  });
});
